import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';
import { useDisclosure } from '@withjoy/joykit';
import { useEffect } from 'react';

export const useMobileSheetDisclosures = () => {
  const isMobileOrTablet = useIsMobileOrTablet();
  const { isOpen: isFilterPanelOpen, onOpen: onFilterPanelOpen, onClose: onFilterPanelClose } = useDisclosure();
  const { isOpen: isSearchOpen, onOpen: onSearchOpen, onClose: onSearchClose } = useDisclosure();
  useEffect(() => {
    if (!isMobileOrTablet) {
      onFilterPanelClose();
      onSearchClose();
    }
  }, [isMobileOrTablet, onFilterPanelClose, onSearchClose]);

  return { isFilterPanelOpen, onFilterPanelOpen, onFilterPanelClose, isSearchOpen, onSearchOpen, onSearchClose };
};
